import { useLazyQuery } from '@apollo/client';
import { Sidebar } from '@insurancemenu/imenu-components-lib';
import { GET_USER_BY_ID } from 'api/queries/userService';
import AdditionalAccess from 'components/common/group/sidebar/AdditionalAccess';
import ContactInfo from 'components/common/group/sidebar/ContactInfo';
import Notes from 'components/common/group/sidebar/Notes';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useRootStore } from 'store/rootStore';
import { FullUser } from 'types/userService';
import ContactBlock from '../../common/group/sidebar/ContactBlock';
import { createStyles } from './styles';

const EmployerSidebar: React.FC = observer(() => {
  const {
    subscriberStore: { activeGroup },
    userStore: { isLoading },
    domainStoreV2: { domainHeader },
  } = useRootStore();

  const { agentOfRecord } = activeGroup;

  const [getUserByIdQuery, { data }] = useLazyQuery<{
    userById: FullUser;
  }>(GET_USER_BY_ID, {
    fetchPolicy: 'no-cache',
    variables: {
      userId: agentOfRecord?.id,
    },
  });

  useEffect(() => {
    if (agentOfRecord?.id) {
      void getUserByIdQuery();
    }
  }, [getUserByIdQuery]);

  const classes = createStyles();

  const AORName =
    data?.userById?.firstName || data?.userById?.lastName
      ? `${data?.userById?.firstName} ${data?.userById?.middleName || ''} ${data?.userById?.lastName}`
      : '';

  return (
    <Sidebar className={classes.sidebar}>
      {!isLoading && activeGroup.id && (
        <>
          <ContactInfo />
          <AdditionalAccess groupId={activeGroup.id} editableType="NONE" />
          {activeGroup.agentOfRecord && (
            <ContactBlock
              blockTitle={domainHeader.id === '123' ? 'Carrier Contact Information' : 'Agent Information'}
              info={{
                name: agentOfRecord?.id ? AORName : agentOfRecord?.name || '',
                phone: agentOfRecord?.id ? data?.userById.telephone || '' : '',
                email: agentOfRecord?.id ? data?.userById.email || '' : agentOfRecord?.email || '',
              }}
            />
          )}
          <Notes employerGroupId={activeGroup.id} />
        </>
      )}
    </Sidebar>
  );
});

export default EmployerSidebar;
